import { ref, onMounted } from '@vue/composition-api'
import { getCrmEnum } from '@/api/crm/label.js'

// 查crm相关数据字典
export const useCrmDic = () => {
  const dicOptions = ref({})
  const queryCrmDic = async () => {
    const { code, data } = await getCrmEnum()
    if (code !== 0) {
      return
    }
    dicOptions.value = data
  }
  // 字典转换
  const getLabelByCode = (code, dicArr) => {
    if (!Array.isArray(dicArr)) {
      return ''
    }
    const obj = dicArr.find((f) => parseInt(f.value) === parseInt(code))
    if (obj) {
      return obj.label
    }
    return ''
  }

  onMounted(() => {
    queryCrmDic()
  })

  return {
    dicOptions,
    getLabelByCode,
    queryCrmDic
  }
}
